import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

// import required modules
import { EffectCards, Autoplay } from "swiper/modules";
import { CONSTANT } from "../../../../../constant/Constant";
import { INVITATION } from "../../../../../api/Invitation";

export const WishesSession = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const getRandomColor = () => {
    const customColors = [
      "#FFB3BA", // light red
      "#FFDFBA", // peach
      "#FFFFBA", // soft yellow
      "#BAFFC9", // mint
      "#BAE1FF", // baby blue
      "#E3BAFF", // lavender
    ];
    return customColors[Math.floor(Math.random() * customColors.length)];
  };
  const [wishData] = useState({
    wish: "",
    name: "",
  });
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("* Required"),
    wish: Yup.string()
      .required("* Required")
      .max(200, "Wish must be 200 characters or less"),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    const wishArray = data.wishes;
    const newData = {
      wish: values.wish,
      from: values.name,
      isApproved: false,
    };
    wishArray.push(newData);
    formData.append("wishes", JSON.stringify(wishArray));
    try {
      setLoading(false);
      const res = await INVITATION.UPDATE(formData, data._id);
      if (res.status === 200) {
        toast.success("Wishes send succesfully");
        closeModal();
      } else {
        toast.error("Failed to Update Invitation");
        throw new Error("failed to create an topic");
      }
    } catch (error) {
      setLoading(false);
      // console.log("error", error);
    }
  };

  const [array, setArray] = useState([]);
  useEffect(() => {
    if (data.wishes.length > 0) {
      const wishArray = [];
      data.wishes.map((itm) => {
        if (itm.isApproved) {
          const newData = {
            wish: itm.wish,
            from: itm.from,
          };
          wishArray.push(newData);
        }
        return wishArray;
      });
      setArray(wishArray);
    }
  }, [data]);

  return (
    <div>
      <div className="pr-10 ">
        <img
          src={`${CONSTANT.UI_URL}flower/${data.flower}`}
          alt="flower"
          className="h-40 "
        />
      </div>
      {array.length > 0 && (
        <Swiper
          effect={"cards"}
          grabCursor={true}
          className="w-[250px] h-[450px] sm:w-[450px] sm:h-[350px] md:w-[550px] lg:w-[750px] xl:w-[70%] lg:h-[200px] "
          autoplay={{
            delay: 2000, // ⏱ Slide every 2 seconds
            disableOnInteraction: false, // Keeps autoplay even after user touches/swipes
          }}
          modules={[EffectCards, Autoplay]}
        >
          {array.map((itm) => (
            <SwiperSlide
              style={{
                backgroundColor: getRandomColor(),
                borderRadius: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="w-full h-full text-center flex justify-center items-center flex-col gap-5 p-10">
                <p className="text-black text-lg font-bubbles">{itm.wish}</p>
                <p className="text-black text-base font-bubbles">
                  ♡ {itm.from}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      <div className="py-20 flex justify-center items-center">
        <button
          className="border-2 p-2 rounded-full flex gap-2 px-5"
          onClick={openModal}
        >
          Send Your wishes ♡
        </button>
      </div>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg max-w-sm w-full shadow-lg">
            <Formik
              initialValues={wishData}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {(formik) => (
                <Form>
                  <div className="">
                    <div className=" pt-0">
                      <Field
                        as="textarea"
                        name="wish"
                        placeholder="Type your wish and greetings..."
                        rows={4}
                        maxLength={200}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      />
                      <ErrorMessage
                        name="wish"
                        component="a"
                        className="text-danger"
                      />
                    </div>
                    <div className=" pt-5">
                      <Field
                        placeholder="Tell us who you are"
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                        name="name"
                      />
                      <ErrorMessage
                        component="a"
                        className="text-danger"
                        name="name"
                      />
                    </div>
                    <div className="flex justify-end gap-5 mt-5">
                      <button
                        type="button"
                        className="flex justify-center rounded  text-secondary font-medium text-gray"
                        onClick={closeModal}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="flex justify-center  rounded text-primary font-medium text-gray"
                      >
                        {loading ? (
                          <div className="flex h-auto items-center justify-center ">
                            <div className="h-6 w-6 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
                          </div>
                        ) : (
                          "Send your wishes ♡"
                        )}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </div>
  );
};
